import Vue from "vue";
import Vuex from "vuex";

// modules
import auth from "./modules/auth";
import feeds from "./modules/feeds";
import users from "./modules/users";
import analytics from "./modules/analytics";
import audit from "./modules/audit";
import common from "./modules/common";
import social from "./modules/social";
import manager from "./modules/manager";
import i18 from './modules/i18';
import datePeriod from './modules/datePeriod';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
  modules: {
    common,
    auth,
    feeds,
    analytics,
    users,
    audit,
    i18,
    social,
    manager,
    datePeriod,
  },
  strict: debug
});

export default store;
